import { Component, AfterContentInit, QueryList, ContentChildren } from '@angular/core';
import { AccordionGroupComponent } from './accordion-group/accordion-group.component';
import { merge } from 'rxjs';
import { mapTo, switchMap, startWith } from 'rxjs/operators';

// https://github.com/NetanelBasal/ng-accordion-tutorial/tree/master/@app

@Component({
  selector: 'app-accordion',
  templateUrl: './accordion.component.html',
  standalone: true,
})
export class AccordionComponent implements AfterContentInit {
  @ContentChildren(AccordionGroupComponent)
  groups: QueryList<AccordionGroupComponent>;

  ngAfterContentInit() {
    this.groups.changes
      .pipe(
        startWith(this.groups),
        switchMap(groups => {
          const clicks$ = groups.filter(() => groups.header).map(group => group.header.click$.pipe(mapTo(group)));
          return merge(...clicks$);
        })
      )
      .subscribe();
  }
}
